import useAutoHoverAnimation from '../../hooks/useAutoHoverAnimation';

export default function HeroBanner() {
    const titleRef = useAutoHoverAnimation(100, 100, 600);

    return (
        <>
            <div id="hero">
                <div id="hero-video-background">
                    <img src="/images/admission-page-banner.jpg" alt="Admission Form Hero" />
                </div>
                <div id="hero-styles">
                    <div id="hero-caption" className="height-title content-full-width text-align-center parallax-scroll-caption">
                        <div className="inner">
                            <h1 ref={titleRef} className="hero-title caption-timeline primary-font-title">
                                <div>
                                    <span>A</span>
                                    <span>D</span>
                                    <span>M</span>
                                    <span>I</span>
                                    <span>S</span>
                                    <span>S</span>
                                    <span>I</span>
                                    <span>O</span>
                                    <span>N</span>
                                    <span>&nbsp;</span>
                                    <span>F</span>
                                    <span>O</span>
                                    <span>R</span>
                                    <span>M</span>
                                </div>
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}